import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-application-lookup',
  templateUrl: './micro-application-lookup.component.html'
})
export class MicroApplicationLookupComponent  {

  @Input()
  applicationId:any;

  @Input()
  link:boolean = true;
}
